<template>
<div  class="container-fluid">


<dialogBoxModal  v-if="dialogBox.show" @close="closeDialogBoxModal()" v-bind:props="dialogBox" ></dialogBoxModal>
<waitingBoxModal v-if="waitModal.show" @close="closeWaitingModal()"  v-bind:props="waitModal" ></waitingBoxModal>
<editRowModal    v-if="rowModal.show" v-bind:props="rowModal" @close="closeEditRowModal" @update="updateCartRow"></editRowModal>
<discountModal   v-if="discountModal.show" @close="closeDiscountModal()" @update="setCartDiscount"></discountModal>
<confirmBoxModal v-if="confirmBoxModal.show" v-bind:props="confirmBoxModal" @close="closeConfirmBoxModal()"></confirmBoxModal>



<fiscalPrinter   v-if="fiscalPrinter && getFiscalPrinter1(fiscalPrinterNew.fpId)" v-bind:giftTicket="false" @close="fiscalPrinter=false" @finish="fiscalPrinter=false"  v-bind:saleId="saleId" v-bind:deskId="deskId" v-bind:fiscalReceiptSaleId="fiscalReceiptSaleId"></fiscalPrinter>
<fiscalPrinterNew v-if="fiscalPrinterNew.show && getFiscalPrinter2(fiscalPrinterNew.fpId)" v-bind:data="fiscalPrinterNew" @close="closeFiscalPrinter()"> </fiscalPrinterNew>

<shopAssistant v-if="shopAssistant.show" v-bind:data="shopAssistant.data" v-bind:rowIndex="rowIndex" @close="closeShopAssistantModal()"  @update="setShopAssistant"></shopAssistant>

<AssistantConfig v-if="shopAssistant.config" @update="setShoppingAssistantConfig" ></AssistantConfig>

<button v-if="showReturnButton"     @click="gotoCart()" class="btn btn-secondary btn-block border border-warning  mb-1">
      <i style="color:yellow" class="fas fa-reply mr-2" aria-hidden="true"></i>
      RITORNA ALLA VENDITA
</button>



<div v-if="type=='sales'">
  <sales v-bind:barcode="ean" @close="setSaleDataItem"></sales>
</div>


<div v-else-if="type=='GiftCardValidate'">
  <GiftCardValidate></GiftCardValidate>
</div>


<div v-else-if="type=='GiftCardCreate'">
  <GiftCardCreate></GiftCardCreate>
</div>

<div v-else-if="type=='GiftCardPrintBarcode'">
  <GiftCardPrintBarcode></GiftCardPrintBarcode>
</div>


<!-- CUSTOMER PAYMENT-->
<div v-else-if="type=='setPayment'">
  <customerPayment v-bind:customerId="customer.customerId" v-bind:saleId="saleData.saleId"></customerPayment>
</div>


<div v-else-if="type=='movements'">
  <movements v-bind:item="item"></movements>
</div>

<div v-else-if="type=='printBarcodes'">

  <div class="card border-info mb-3" >
  <div class="card-header bg-info text-white">STAMPA ETICHETTA</div>
  <div class="card-body text-info">
    <h4 :style="{color:'black'}" class="card-title"><strong>{{ item.brand }} - {{ item.sku }} - {{ item.category }} </strong> </h4>
    <printBarcodes v-bind:item="item"></printBarcodes>  
  </div>
</div>
  
</div>

<div v-else-if="type=='stockMovement'">
  <stockMovementToStore   v-bind:cart="cart"   @close="closeStockMovementToStore"></stockMovementToStore>
</div>



<div v-else-if="type=='stock'">
  <stock v-bind:margin="80" @close="closeStock" v-bind:item="item" />
</div>

<div v-else-if="type=='lastSale'">
  <lastSale v-bind:storeId="storeId" v-bind:deskId="deskId"  />
</div>

<div v-else-if="type == 'coupon'">
  <coupon @close="gotoCart()"   v-bind:cart="true"></coupon>
</div>

<div v-else-if="type == 'customers'">
  <customerList @close="setCustomer"></customerList>
</div>

<div v-else-if="type == 'productSearch'">
  <productSearch  @close="setBarcode"  />  
</div>

<div v-else-if="type == 'checkOut'">  
  <checkOut v-bind:checkOut="checkOut" @close="checkOutClose" @cancel="checkOutCancel"/>
</div>

<div  v-else>
  <div class="card border-primary bg-light text-white">
    <div style="background-color:#0066FF" class="card-header main">      
      <h4><i style="color:yellow" class="fas fa-shopping-cart mr-3" aria-hidden="true"></i>VENDITA AL BANCO</h4>        
    </div>  
    
    <div class="card border border-success rounded">
     
      <div class="card-body">
        
        
          <div class="row">
          
          <desk class="ml-4 mr-2" @setDesk="setDesk"></desk> 
          
          <button  type="button" @click="setShoppingAssistantConfig(true)" class="btn btn-secondary border border-info btn-sm mr-1">OPZIONI
              <i  class="fas fa-cog ml-2" aria-hidden="true"></i>
              <!--
              <i v-if="shopAssistant.option==0" class="fas fa-cog ml-2" aria-hidden="true"></i>
              <i style="color:black" v-if="shopAssistant.option==1" class="fas fa-shopping-cart ml-2" aria-hidden="true"></i>
              <i style="color:black" v-if="shopAssistant.option==2" class="fas fa-cash-register ml-2" aria-hidden="true"></i>
              -->
          </button> 
          <toolBar class="mt-0" @update="toolBarButton"></toolBar>   
          
          <sseModal class="ml-3"></sseModal>        

          </div>          
      </div>
    </div>

    <!-- CARD BODY -->
    <div class="card-body"> 
          
        <!-- CUSTOMER -->
        <customer v-if="customer.show" @close="setDefaultCustomer" v-bind:customer="customer"></customer>

        <!-- SALE DATA -->
       

        <!-- CART -->
        <div class="table-wrapper-scroll-y my-custom-scrollbar ml-2 mr-2">
        <table  class="cart table table-hover table-bordered_ mb-0">
          <thead>
            <tr class="table-active">
              
              <th>#</th>
              <th></th>
              <th><i class="fas fa-user-tag mr-2" aria-hidden="true"></i></th>
              <th>
                <i class="fas fa-exchange-alt	" aria-hidden="true"></i>
              </th>
              <th></th>      
              <th></th>  
              <th></th>     
              <th>BRAND</th>
              <th>CODICE</th>  
              <th>DESCRIZIONE</th>      
              <th>EAN</th>      
              <th>COLORE</th>
              <th>MISURA</th>
              <th class="text-right">ESISTENZA</th>      
              <th class="text-right text-nowrap">IMPORTO €</th>       
              <th class="text-right text-nowrap">% SCONTO</th>            
              <th class="text-right text-nowrap">TOTALE €</th>
              
            </tr>
            </thead>
            <tbody>
            <!-- BODY  --> 
            <tr data-toggle="tooltip" title="doppio click modifica riga" @dblclick="editRowModal(item,index)"   class="pointer"  :class="`index-${index}`"  v-for="(item,index) in cart" :key="index">
              <td>{{index+1}}</td> 
              
              <td>
                  <button class="btn btn-default"   @click="setDeleteBoxModal(index)"><i style='color:black;' :style="{fontSize: '26px'}" data-toggle="tooltip" title="elimina riga"  class="fas fa-trash"  aria-hidden="true"></i></button>                         
              </td>
              
              <td>{{item.assistant_code}}</td>
              
              <td>
                <input  :disabled="item.edit == 1" class="pointer largerCheckbox" @click="setRowType(index)" type="checkbox" v-bind:value="item.type" v-model.number="item.type">
                <small v-if="item.type == true" style="color:red" id="reso" class="form-text text-nowrap "><strong>RESO DA CLIENTE</strong></small>
              </td>

              <td>
                <button  class="btn btn-default"  @click="setProductStock(item)"><i style='color:#736AFF;'  :style="{fontSize: '26px'}" data-toggle="tooltip" title="Stock"  class="fa fa-database" aria-hidden="true"></i></button></td>                       
              <td>
                  <button class="btn btn-default" @click="setMovementList(item)">
                  <i style="color:blueviolet" :style="{fontSize: '26px'}"  data-toggle="tooltip" title="Movimenti" class="fas fa-list-ol" aria-hidden="true"></i>
                  </button>  
              </td>  

              <td>
                <button  class="btn btn-default"  @click="setPrintBarcodes(item)"><i style='color:brown'  :style="{fontSize: '26px'}" data-toggle="tooltip" title="Stampa etichetta"  class="fas fa-tag" aria-hidden="true"></i></button>
              </td>
              <td style="color:navy"  :style="{fontSize: '20px'}" class="text-nowrap">{{item.brand}}</td>
              <td style="color:navy"  :style="{fontSize: '20px'}" class="text-nowrap"> {{item.sku}}</td>
              <td style="color:navy"  :style="{fontSize: '20px'}" class="text-nowrap">{{item.category}}  -  {{item.season}} {{item.season_year}} {{ item.department }}
                <div><span><small>{{item.description}}</small></span></div>
              </td>
                
              <td style="color:navy" :style="{fontSize: '20px'}">
                  <a @click="getItemSales(index)">{{item.barcode}}
                    <i data-toggle="tooltip" :style="{fontSize: '20px'}" title="Info vendite." class="fas fa-info-circle ml-1" aria-hidden="true"></i>
                  </a>  
              </td> 
        
              <td style="color:navy" :style="{fontSize: '20px'}" class="text-nowrap">{{item.color}}</td>
              <td style="color:navy" :style="{fontSize: '20px'}">{{item.size}}</td>
              <td style="color:navy" :style="{fontSize: '20px'}"  class="text-right">
                <span style="color:red" v-if="item.qtyStock<=0"> <strong>{{item.qtyStock}}</strong></span>
                <span v-else>{{item.qtyStock}}</span>
              </td>
              <td class="text-right" :style="{color : item.price != item.retail_price ? 'red' : 'darkgreen'}"  style="font-size:20px;font-weight:bold">
                {{fmt1(item.price) }}
              </td>
              <td class="text-right"  :style="{color : item.discount > 0 ? 'red' : 'darkgreen' ,fontWeight: 'bold',fontSize:'20px'}" >
                  {{item.discount}}
                  <!--<small class="form-text text-nowrap"><span v-if="item.discount_info">{{item.discount_info}}</span></small>-->
              </td>            
              <td  style="color:darkgreen;font-weight: bold;font-size:22px" class="text-right">
                {{fmt1(item.rowTotal)}}
              </td>                
            </tr> 
            </tbody>  
            <tfoot >
            <tr> 
              <th>
                <span  data-toggle="tooltip" title="Articoli venduti" class=" pointer badge  badge-info ">{{total.type[0]}}</span> 
              </th>
              <th>
                <span v-if="total.type[1]>0" data-toggle="tooltip" title="Articoli resi" class="pointer badge  badge-danger ">{{total.type[1]}}</span>
              </th>                    
              <th>
                <span v-if="barcodeDuplicationCheck > 0" data-toggle="tooltip" title="Articoli ripetuti" class="pointer badge  badge-warning ">{{barcodeDuplicationCheck}}</span>
              </th>
              <th></th>              
              <th></th>        
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>           
              <th></th>
              <th></th>
              
              <th></th>
              <th></th>
              <th class="text-right text-nowrap" style="color:#2e8b57;font-size:45px">
                <i v-if="total.round_total > 0" style='color:red;font-size: 12px;'  class="mr-2" aria-hidden="true">
                  <span>(+ {{total.round_total}})</span>
                </i>
                <span style="font-size:40px;" class="badge badge-pill badge-success">
                    {{fmt1(total.subTotal2)}} €
                </span>        
              </th>                
            </tr>   
            </tfoot>    
              
          </table>
          </div>

          <div>
            <ModalSaldoRitiroCliente v-if="saleData.create_at"  @close="closeSaleData()" @setPayment="setCustomerPayment('setPayment')" v-bind:props="saleData"></ModalSaldoRitiroCliente>            
          </div>
          
  <!-- CARD BODY-->
  </div>

<!-- CARD FOOTER -->
<div class="card-footer border-primary bg-transparent">
<div class="float-left">
   <h4 style="color:black">RESTO <span class="badge bg-success rest ml-3">       
    {{rest}} €  
     </span></h4>
</div>


<div class="float-right">
    <button  :disabled="cart.length==0" @click="setCheckOut()"  class="btn btn-primary border border-warning  btn-lg   mr-4">
      
    <i style="color:yellow;font-size: 26px;"  class="fas fa-cash-register mr-2" aria-hidden="true"></i>
    TERMINA E PAGA</button>
 </div>
</div>

</div>        
</div>

</div>
</template>

<script>

const synth = window.speechSynthesis
let voices  = []
voices      = synth.getVoices()

import customerPayment    from '@/components/rt/CustomerPayment.vue'
import dialogBoxModal     from '@/components/frontOffice/cart/dialogBoxModal.vue'

import stock              from '@/components/product/productStock.vue'
import waitingBoxModal    from "@/components/common/WaitingModal.vue"
import saleData           from '@/components/frontOffice/cart/SaleData.vue'
import confirmBoxModal    from '@/components/frontOffice/cart/confirmBoxModal.vue'
import editRowModal       from '@/components/frontOffice/cart/EditRowCartModal.vue'
import toolBar            from '@/components/frontOffice/cart/toolBar.vue'

import sales              from '@/components/frontOffice/ProductAllSales.vue'
import movements          from '@/components/backOffice/ready/tab/MovementPivot.vue'
import printBarcodes      from '@/components/backOffice/ready/tab/PrintBarcodes.vue'
import lastSale           from '@/components/frontOffice/cart/LastSale.vue' 
import discountModal      from '@/components/frontOffice/cart/cartDiscountModal.vue'

import stockMovementToStore      from '@/components/frontOffice/cart/stockMovementToStore.vue'

import coupon             from '@/components/frontOffice/coupon/CouponList.vue'
import customer           from '@/components/frontOffice/cart/SetCustomer.vue'
import customerList       from '@/components/frontOffice/customer/CustomerList.vue'
import productSearch      from '@/components/frontOffice/cart/ProductSearch.vue'
import sseModal           from '@/components/sse/MessageModal.vue'
import checkOut           from '@/components/frontOffice/CheckOut.vue'
import shopAssistant      from '@/components/frontOffice/cart/shopAssistant.vue'
import AssistantConfig    from '@/components/frontOffice/cart/AssistantConfig.vue'
import fiscalPrinter      from '@/components/rt/FiscalPrinter.vue'
import fiscalPrinterNew   from '@/components/rt/FiscalPrinterNew.vue'
import desk               from '@/components/common/Desk.vue'
import ModalSaldoRitiroCliente from './ModalSaldoRitiroCliente.vue'
import GiftCardCreate     from '@/components/frontOffice/caposerio/GiftCardCreate.vue'
import GiftCardValidate   from '@/components/frontOffice/caposerio/GiftCardValidate.vue'
import GiftCardPrintBarcode from '@/components/frontOffice/caposerio/GiftCardPrintBarcode.vue'


import api                from '@/api'
import fmt                from '@/components/mixins/fmt.js'
import selfCash           from '@/components/mixins/SelfCash.js'
import SapiaClub          from '@/components/mixins/SapiaClub.js'



//import onScan             from 'onscan.js'
import scannerDetection   from '@/scanner';  

import _                  from "lodash";
import { mapGetters }     from 'vuex'








export default {
  
  mixins     : [fmt,selfCash,SapiaClub],  
  components : {
                stockMovementToStore,
                saleData,
                dialogBoxModal,                
                waitingBoxModal,
                
                confirmBoxModal,
                editRowModal,
                sales,
                movements,
                stock,
                toolBar,
                lastSale,
                discountModal,
            
                coupon,customer,
                customerList,
                productSearch,
                sseModal,
                shopAssistant,
                AssistantConfig,
                checkOut,
                fiscalPrinter,
                fiscalPrinterNew,
                desk,customerPayment,ModalSaldoRitiroCliente,printBarcodes,GiftCardCreate,GiftCardValidate,GiftCardPrintBarcode
                },
  props      : [],
  data () 
  {
    return {

      

      fiscalReceiptSaleId : 0,
      saleData        : {
          create_at   : ''
      },        
      deskId          : 1,
      type            : 'cart',
      rowModal        : 
      {
        show          : false
      },
      movementModal   :
      {
        show          : false
      },
      discountModal   : 
      {
        show          : false
      },
      waitModal       : 
      {
        sentinel      : 0,
        show          : false,
        msg1          : '',
        msg2          : '' 
      },
  
      confirmBoxModal :
      {
        show          : false
      },
      dialogBox       : {
        show          : false,
        msg           : ''
      },

      cart            : [],
      item            : {},
      _price          : 0,
      _discount       : 0,
      productId       : 0,
      scan_barcode    : '',
      ean             : '',
      
      
      rowIndex        : -1,
      customer        : {},
      checkOut        : {},
      shopAssistant   : 
      {
             config   : false,
             show     : false,
             option   : 0,
             checkOut : false,
             data     : 0
      },
    
      rest                : '0,00',
      fiscalPrinter       : false,
      saleId              : 0,
      
      payment             : {},
      
      fiscalPrinterNew    : {
        receiptSaleId     : 0,
        show              : false,
        fpId              : 0
        
      }

      

      }
  },


    watch: {
    
    cart : function (value) 
    {            
      const btn  = value.length > 0 ? 1 : 0
      this.$store.commit('AUTH_LOGOUT_BTN',btn)      
    }
    },
  computed: 
  {
    ...mapGetters(['storeId','company','logout_btn','isAdmin']) , 

    showReturnButton() {
      return this.type !== 'cart' && this.type !== 'checkOut' && this.type !== 'stock' && this.type !== 'coupon' && this.type != 'stockMovement'
    },

    total : function() {
     
      const total      = {totalItem:0,subTotal1:0.00,subTotal2:0.00,items:0,type:[],round_total:0.00}
      let grandTotal   = 0.00
      total.type[0]    = 0
      total.type[1]    = 0
      
      this.cart.forEach(item => {
     
          total.type[item.type == true ? 1:0] += 1   
          total.subTotal1  += item.price * item.qtyOnSale * (item.type === false ? 1 : -1)                           
          const rowTotal   = this.roundToDecimals(item.rowTotal ,2)      
          grandTotal       = Number(grandTotal.toFixed(2)) + Number(rowTotal)          
          total.subTotal2  = grandTotal
          if(item.round_total > 0 )
          {            
            total.subTotal2  = this.roundTotal(grandTotal,item.round_total)            
          }                    
          total.items  += 1
          total.round_total = Number(Math.round(total.subTotal2 - grandTotal + 'e2' ) + 'e-2' ).toLocaleString('en-US', {minimumFractionDigits: 2}).replace(',','')      
          
      })
      return total
    },
   
   
    barcodeDuplicationCheck : function()
    {        
      const  obj = _.groupBy(this.cart, 'barcode')
      const arr = []      
      Object.keys(obj).forEach(item=>
      { 
       arr.push({'barcode':item,'total':0})  
        
      })
      arr.forEach(item=>{
        this.cart.forEach(p=>{
          if(item.barcode == p.barcode )
          {
            item.total = item.total + 1
          }
        })
      })
      
      const total = arr.filter(item => item.total > 1)
      return total.length
    }     
  },    
  
  mounted : function()
  {
    this.setScannerOn()   
    const option = JSON.parse(localStorage.getItem("ShoppingAssistantOption"))
    if(option)
    {
      this.shopAssistant.option = option
    }
    const deskId = JSON.parse(localStorage.getItem("deskId"))    
    if(deskId)
    {    
      this.deskId = Number(deskId)
    }
    this.storeSelfCashApi(this.storeId,this.deskId) 
    this.getSapiaClubPricesList()
  },
  beforeDestroy () {       
   this.setScannerOff()   
  },
  methods: 
  {
    /*
     handleReturnButton(status) {
      // il figlio può dire se disabilitare o meno
      console.log('STATUS',status)
      this.disableReturnButton = status;
    },
    */

    closeStockMovementToStore(reset)
    {
      if(reset)
      {
        this.cart = []
      }
      this.type = 'cart'

    },
    setCustomerPayment(type)
    {
      this.type = type
    },
    getFiscalPrinter1(Id)
    {
      
      if(Id == 0 || Id == 1 || Id == 6)
      {
        return false
      }
      else
      {
        return true
      }
    },
    getFiscalPrinter2(Id)
    {
      if(Id == 1 || Id == 6)
      {
        return true
      }
      else
      {
        return false
      }
    },
    closeFiscalPrinter()
    {
      this.fiscalPrinterNew.show          = false
      this.fiscalPrinterNew.receiptSaleId = 0
      this.fiscalPrinterNew.fpId          = 0
    },
    initScan()
    {
      $(document).scannerDetection(data => 
      {
   
      onComplete:      
        this.handleBarcode(data)
      });
     
    },

    closeSaleData()
    {
      this.saleData = {}
      
    },
    closeDialogBoxModal()
    {
      this.setScannerOn()
      this.dialogBox.show = false
    },

    closeShopAssistantModal()
    {
      this.shopAssistant.show = false
      if(this.shopAssistant.checkOut)
      {
        this.saveCart()
        this.type = 'checkOut'  
      }
      

    },
    setShopAssistant(code,index)
    {
      this.shopAssistant.show = false
      this.shopAssistant.data = Number(code)
      if(code)
      {
        
        if(index==0)
        {
          this.cart.forEach(item=>
            {
              item.assistant_code = code
            }
          )
          
        }
        else
        {
          this.cart[index]['assistant_code'] = code
        }
      
      }

      

      /* GOTO CHECKOUT */
      if(this.shopAssistant.checkOut)
      {
        
      //  this.shopAssistant.show = false
        this.saveCart()
        this.type = 'checkOut'
      } 
        
    },
    setShoppingAssistantConfig(value,option)
    {
      this.shopAssistant.config = value      
      this.shopAssistant.option = option
    },
    async checkOutClose(option)
    {
      this.shopAssistant.data = 0
      this.rest = option.rest
      this.setScannerOff()    
      this.setScannerOn()
      this.type = 'cart'

      let total = ''
      if(option.payment.length > 0)
      {
        option.payment.forEach(item=>{
        if(item.typeId == 'CASH')
        {                    
          total = this.fmt1(item.amount).replace(',','')          
        }

      })
      }
      
     
      if(total) 
          { 
           
            this.sendTotalToSelfCash(total)
           
          }

      
          
      this.saleData      = {}
      this.cart          = []
      this.setDefaultCustomer()
      
      if(option.print_receipt)
      {        
        this.saleId = option.saleId  
        
        this.fiscalPrinter = true      
                
        console.log('OPZIONI CHECKOUT',option)
        
        this.setFiscalPrinter(option)        
  
      }


    },

    setFiscalPrinter(data)
    {
        
        if(data.fp.component)
        {
          this.fiscalPrinterNew.component           = data.fp.type + data.fp.component 
          this.fiscalPrinterNew.saleId              = data.saleId
       
          this.fiscalPrinterNew.url                 = data.fp.url
          this.fiscalPrinterNew.serialNumber        = data.fp.badge
          this.fiscalPrinterNew.fpId                = data.fp.fpId
          this.fiscalPrinterNew.show                = true
        }
       
    },
    checkOutCancel()
    {
      
      this.setScannerOff()
      this.setScannerOn()
      this.shopAssistant.show  = false
      this.type                = 'cart'
      
    },
    saveCart()
    {
      const obj        = {}          
      
      localStorage.removeItem('cart')
      localStorage.removeItem('barcode')
      localStorage.removeItem('customer')    

      //this.saveCustomer(this.customer)

      obj.customerId   = this.customer.customerId ? this.customer.customerId : 0
      obj.customer     = this.customer.last_name  ? this.customer.last_name + ' ' + this.customer.first_name : 'CLIENTE BASE'
      obj.deskId       = this.deskId
      //obj.cb           = this.customer.cb ? this.customer.cb : 0
      obj.cb           = this.customer.cashback ? this.customer.cashback : 0

      /* CAPOSERIO */
      obj.saleTypeId   = this.saleTypeId


      if(this.cart.length > 0)
      {
        //this.setDesk(this.deskId)
        obj.rows        = this.cart
        obj.total       = this.total.subTotal2

        obj.subtotal    = this.total.subTotal1
        obj.round_total = this.total.round_total

        localStorage.setItem('cart', JSON.stringify(obj));
             
      }
      this.checkOut = obj
      //console.log('CHECKOUT',obj)
      
    }, 
    
    
    setCheckOut()
    {
      this.setScannerOff()
      
      if(this.shopAssistant.option == 2)
      {
        if(this.cart.length > 0)
        {                    
          this.rowIndex               = 0
          this.shopAssistant.show     = true
          this.shopAssistant.checkOut = true
                              
        }
      }
      else
      {
      if(this.cart.length > 0)
      {        
        this.saveCart()
        this.type = 'checkOut'              
      }
      }

    },
    setDefaultCustomer()
    {
      this.customer = {}
    },

    
    setDesk(deskId)
    {
      this.deskId = deskId
      localStorage.setItem('deskId',JSON.stringify(deskId))
      this.storeSelfCashApi(this.storeId,this.deskId)
    },
    setCustomer(item)
    {
      
      /* IF COMES FROM SALE */
    
      this.setScannerOff()
      this.setScannerOn()
      
      this.customer      = item
      this.customer.show = true
      this.type          = 'cart'

    },
    closeMovementModal()
    {
      // this.setScannerOn()
      this.movementModal.show = false
    },
    closeConfirmBoxModal()
    {
      //this.setScannerOn()
      this.setConfirmBoxModal(false)
    },
    setConfirmBoxModal(show,title,msg,method)
    {
      this.confirmBoxModal.show    = show
      this.confirmBoxModal.title   = title
      this.confirmBoxModal.msg     = msg
      this.confirmBoxModal.method  = method
            
    },
    resetCart()
    {
      
      this.cart        = []      
      this.saleData    = {}     
      this.setDefaultCustomer()
      this.fiscalPrinterNew.receiptSaleId = 0
    },
    getCartFromSession()
    {
       
        const obj = JSON.parse(localStorage.getItem('sandbox'))
        if(obj)
        {
                   
          this.customer = obj.customer
          this.cart = obj.cart  
        }

    },
    saveCartToSession()
    {
      let sandbox    = {}
      let obj        = {}          
      
      if(this.cart.length > 0)
      {
                  
        obj.cart       = this.cart
        obj.total      = this.total.subTotal2
        obj.subtotal   = this.total.subTotal1
        obj.customer   = this.customer
        obj.deskId     = this.deskId 
        sandbox        = obj

        localStorage.setItem('sandbox',JSON.stringify(sandbox));

        this.resetCart()


      }
        
    },
  
    toolBarButton(type)
    { 
      
      if(type == 'GiftCardCreate')
      {
        this.setScannerOff()
        this.type = type
      }
      if(type == 'GiftCardValidate')
      {
        this.setScannerOff()
        this.type = type
      }

      if(type == 'GiftCardPrintBarcode')
      {
        this.setScannerOff()
        this.type = type
      }

      if(type == 'productSearch')
      {
        this.setScannerOff()
        this.type = type
      }

      if(type == 'customers')
      {
        this.setScannerOff()
        this.type = type        
      }
      if(type == 'saveCartToSession')
      {
        if(this.cart.length > 0)
        {
          this.setConfirmBoxModal(true,'SOSPENDI CARRELLO','GLI ARTICOLI SUL CARRELLO VERRANNO ELIMINATI.',this.saveCartToSession)  
        }        
      }
          
      if(type == 'getCartFromSession')
      {
        if(this.cart.length > 0)
        {
          this.setConfirmBoxModal(true,'RIPRENDI CARRELLO','GLI ARTICOLI SUL CARRELLO VERRANNO ELIMINATI.',this.getCartFromSession)  
        }
        else
        {
          this.getCartFromSession()
        }
      }

      if(type == 'coupon')
      {
        this.setScannerOff()
        this.type = type
      }
      /*
      if(type == 'storeMovement')
      {
        if(this.cart.length > 0)
        {          
          this.movementModal.show = true  
        }
      }
      */
      if(type == 'storeMovement')
      {
        if(this.cart.length > 0)
        {          
          this.type = 'stockMovement'
        }
      }
     
      if(type =='resetCart')
      {         
        if(this.cart.length > 0)
        {
          this.setConfirmBoxModal(true,'RESET CARRELLO','GLI ARTICOLI SUL CARRELLO VERRANNO ELIMINATI.',this.resetCart)
        }
          
      }
      if(type == 'lastSale')
      { 
        this.setScannerOff()     
        this.type = 'lastSale'
      }
      if(type == 'cartDiscount')
      { 
        this.setScannerOff()       
        if(this.cart.length > 0)
        {         
          this.discountModal.show = true
        }
      }
      /*
      if(type == 'customerPayment')
      {
        this.type = type
      }
       */ 
   
    },
    closeDiscountModal()
    {

      
      this.setScannerOff()
      this.setScannerOn()
      this.discountModal.show = false
    },
    closeStock(barcode)
    {
      this.type = 'cart'
      if(barcode)
      { 
        //console.log('CLOSE STOCK')  
        this.getData(barcode)                  
      }  
      

    },
    setBarcode(barcode)
    { 
      
      this.setScannerOff()
      this.setScannerOn()     
      
      this.type = 'cart'
      if(barcode)
      {   
        this.getData(barcode)                  
      }  
    },
    gotoCart()
    {
      // FROM CUSTOMER PAYMENT
     
      
      const customerPayment = JSON.parse(localStorage.getItem("customerPayment"))         
      if(customerPayment == 'YES')
      {
        this.saleData = {}
        this.resetCart()
      }

      this.setScannerOff()
      this.type = 'cart'      
      this.setScannerOn()
    },
    
    setProductStock(item)
    { 
      
      this.item = item
      this.type = 'stock'
    },
    setPrintBarcodes(item)
    { 
      
      this.item = item
      this.item.cart = true
      
      this.type = 'printBarcodes'
    },

    setMovementList(item)
    {
      this.setScannerOff()
      if(this.company.Id > 0)
      {
        this.item = item
        this.type = 'movements'
      }

    },
    setCartDiscount(discount)
    { 
      
      this.setScannerOff()
      this.setScannerOn()
      this.discountModal.show = false     
      for(var i=0; i < this.cart.length; i++)
      {
         if(this.cart[i].edit == null)
         {
          this.cart[i].discount =  Number(parseInt(discount))
          this.cart[i].rowTotal =  this.getRowTotal(this.cart[i])
         }
      }      
    },
    setSaleDataItem(returnPrice,saleId)
    {
      
      
      this.fiscalPrinterNew.receiptSaleId = saleId

      this.type                             = 'cart'
      this.cart[this.rowIndex]['price']     = returnPrice 
      this.cart[this.rowIndex]['discount']  = 0
      this.cart[this.rowIndex]['rowTotal']  = returnPrice * -1
      this.cart[this.rowIndex]['type']      = true
      //this.setRowType(this.rowIndex)

      
      this.setScannerOff()
      this.setScannerOn()

    },
    getItemSales(rowIndex)
    {
      this.setScannerOff()
      this.rowIndex  = rowIndex
      this.ean   = this.cart[rowIndex]['barcode']     
      
      this.type    = 'sales'      
    },
    updateCartRow(item)
    {
      

      this.rowModal.show                 = false
      const index                        = this.rowIndex      
      const price                        = Number(item.price).toFixed(2)
      
      this.cart[index]['price']          = Number(price)
      this.cart[index]['discount']       = parseInt(item.discount)
      this.cart[index]['type']           = item.type
      this.cart[index]['assistant_code'] = item.assistant_code
      
      this.setScannerOff()
      this.setScannerOn()
      this.saveRow(index)
    },
    saveRow(rowIndex)
    {

      if(this.cart[rowIndex]['price'].length==0)
      {
        this.cart[rowIndex]['price'] = this._price
      }
      if(Number(this.cart[rowIndex]['price']) > 5000)
      {
        this.cart[rowIndex]['price'] = this._price
      }      
      if(this.cart[rowIndex]['discount'].length==0)
      {
        this.cart[rowIndex]['discount'] = this._discount
      }
      if(Number(this.cart[rowIndex]['discount']) > 100)
      {
        this.cart[rowIndex]['discount'] = this._discount
      }
      
      this.cart[rowIndex].rowTotal = this.getRowTotal(this.cart[rowIndex])
      
    },

    closeEditRowModal()
    {
      this.rowModal.show = false
      
      this.setScannerOff()
      this.setScannerOn()
    },


    closeWaitingModal()
    {
      this.waitModal.show = false
      this.waitModal.sentinel = 0
      
    },
    setScannerOn()
    { 
      this.initScan()    
      
      //console.log('SCAN ON')           
    },
    setScannerOff()
    {
      
      $(document).scannerDetection(false);
      
      //console.log('SCAN OFF')           
    },

    
    handleBarcode(data)
    { 
      
      if(data.substring(0,1).toUpperCase() == 'S')
      {
        const saleId = data.substring(1)          
        this.getDataFromSale(saleId)
      }      
      else
      {
        
        if(data.length == 13)
        {
          this.getData(data)
        }
        else
        {
          this.dialogBox.show     = true
          this.dialogBox.title    = 'RICERCA PRODOTTO'
          this.dialogBox.msg      = 'LETTURA CODICE A BARRE ERRATA.'
        }

      }

    },

    deleteItem()
    {
      
      this.cart.splice(this.rowIndex, 1)
      if(this.cart.length == 0)
      {
        this.saleData = {}
      }

            
    },
    setDeleteBoxModal(rowIndex)
    {
      this.rowIndex = rowIndex
      const row = rowIndex+1
      this.setConfirmBoxModal(true,'ELIMINA RIGA ' + row ,"LA RIGA VERRA' ELIMINATA.",this.deleteItem)
      
    },
    setRowType(rowIndex)
    {
      const row_type                   = !this.cart[rowIndex].type
      this.cart[rowIndex].type         = row_type 
      //this.cart[rowIndex].type     = type == false ? true : false

      if(this.cart[rowIndex].flag)
      {

        /* FLAG NOT USED NOW */
        console.log('FLAG',this.cart[rowIndex].flag)
        console.log('rowTotal',this.cart[rowIndex].rowTotal)
        const total = Math.abs(this.cart[rowIndex].rowTotal) * (row_type == true ? -1 : 1)
        //* this.cart[rowIndex].type == false ? 1 : -1
        console.log('Total',total)
        this.cart[rowIndex].rowTotal = total

      }
      else
      {
        this.cart[rowIndex].rowTotal = this.getRowTotal(this.cart[rowIndex])  
      }
      
      
    },
  
    roundToDecimals(value,decimals)
    {
      return Number(Math.round(value + 'e' + decimals) + 'e-' + decimals)      
    },

    getRowTotal(item)
    { 

      const discount_val = this.roundToDecimals((item.price  / 100 * item.discount),2)
      let total          = 0
      
      
      // SALE BY SALE ID 
      if(item.flag  )
      {          
         // item.returnTotal = 0
          
          item.price       = item.rowTotal
          item.discount    = 0
          total            = Number(item.rowTotal)           
      }
      else 
      {   total  = Number(item.price - discount_val)
          /*console.log(Number(item.price - discount_val))*/
          /*
          total  = Number(item.price - discount_val)
          if(discount_val)
          {
            total  = this.roundTo(Number(item.price - discount_val),2)    
          }
          */
          /*console.log(total)*/
      }
      
      //total  = Number(item.price - discount_val)                      
      total  = total * (item.type === false ? 1 : -1)     
      return total      
    }, 

    setCartItems(data)
    {
      

      

      this.cart.push(data)
      const index                     = this.cart.length-1
      this.cart[index].type           = false
      this.cart[index].rowTotal       = this.getRowTotal(this.cart[index])
      this.cart[index].price_saved    = this.cart[index].price
      this.cart[index].discount_saved = this.cart[index].discount                
      this.$nextTick(function () 
      {
        this.scrollToElement(index)
      })                
      if(this.shopAssistant.option == 1 )
      {
                 
        this.rowIndex               = index
        this.shopAssistant.show     = true
        this.shopAssistant.checkOut = false
        

      }


    },
    async getData(barcode)
    {
    
    this.setScannerOff()  
    let sp               = {'sp'         : 'spDataProductByBarcode'}

    const data             = {'barcode'       : barcode ,
                              'storeId'       : this.storeId, 
                              'mpId'          : 0,
                              'companyId'     : this.company.Id,
                              'customer_type' : this.customer.SapiaClub
                            } 

    const json             = Object.assign(data, sp)

    /* WAITING MODAL */    
    this.waitModal.msg1    = 'RICERCA PRODOTTO IN CORSO ...'
    this.waitModal.show    = true
    
    await api.post(json).then(res => {
  
          if(res.status==200)
            {  
                          
               if(res.data.recordsets[0].length==0)
                {                  
                  const msg = new SpeechSynthesisUtterance('ATTENZIONE PRODOTTO INESISTENTE');  
                  msg.voice = voices[11];
                  msg.pitch = 1;
                  msg.rate  = 1;
                  const vocalMsg = JSON.parse(localStorage.getItem("vocalMsg"))
                  if(vocalMsg)
                  {
                    synth.speak(msg);
                  }
  
                  this.waitModal.sentinel = 1             
                  this.dialogBox.show     = true
                  this.dialogBox.title    = 'RICERCA PRODOTTO'
                  this.dialogBox.msg      = 'PRODOTTO INESISTENTE.'
                                
                  return
                }
                if(res.data.recordsets[0][0].qtyStock <= 0)
                {                  
                  const msg = new SpeechSynthesisUtterance('ATTENZIONE PRODOTTO NON DISPONIBILE,CONTROLLARE GIACENZA.');  
                  msg.voice = voices[11];
                  msg.pitch = 1;
                  msg.rate  = 1;
                  const vocalMsg = JSON.parse(localStorage.getItem("vocalMsg"))
                  if(vocalMsg)
                  {
                    synth.speak(msg);
                  }

                  
                }

                this.waitModal.sentinel = 1

                this.setCartItems(res.data.recordsets[0][0])
                this.setScannerOn()
            }
           else if(res.status == 500)
            {

              this.waitModal.sentinel = 1
              this.dialogBox.show     = true
              this.dialogBox.title    = 'RICERCA PRODOTTO'
              this.dialogBox.msg      = res.data
              
                              
                    
           } 
           else
            {
              console.log(res)
              
              this.waitModal.sentinel = 1
              this.dialogBox.show     = true
              this.dialogBox.title    = 'RICERCA PRODOTTO'
              this.dialogBox.msg      = res
              
                               
            } 
        

          }).catch(err => {
            console.log(err)
            this.waitModal.sentinel = 1
            this.dialogBox.title    = 'RICERCA PRODOTTO'
            this.dialogBox.show     = true
            this.dialogBox.msg      = err
            
          }).finally(
            (
            
          ) => {
            //this.setScannerOn()
            //this.setScannerOn()
          

        });


    },
    async getDataFromSale(saleId)
    {
    
    this.setScannerOff()
    this.saleData   = {}
    this.cart       = []  

    const sp        = {'sp'        : 'spSaleBySaleIdNew'}
    const data      = {'saleId'    : saleId, 
                       'companyId' : this.company.Id
                      } 
    const json      = Object.assign(data, sp)
    this.waitModal.msg1    = 'RICERCA VENDITA IN CORSO ...'
    this.waitModal.show = true
    
    await api.post(json).then(res => {
	  if(res.status==200)

    {
      this.waitModal.sentinel = 1
      if(res.data.recordsets[0].length==0)
          {
            
                  
            this.dialogBox.show     = true
            this.dialogBox.title    = 'RICERCA VENDITA'
            this.dialogBox.msg      = 'VENDITA INESISTENTE.'
            
            return
          } 

      this.setDefaultCustomer()
      if(res.data.recordsets[0][0].customerId > 0)
          {
           
           this.setCustomer(res.data.recordsets[0][0])

          }
          
          /* GET CREDIT NOTE FISCAL RECEIPT DATA */
          this.fiscalPrinterNew.receiptSaleId = saleId
          

          this.saleData.create_at = res.data.recordsets[0][0].create_at    
         
          this.saleData.items     = res.data.recordsets[1]
          this.saleData.discount  = res.data.recordsets[0][0].totalDiscount
          this.saleData.total     = res.data.recordsets[0][0].total
          this.saleData.saleId    = saleId
          this.saleData.customerId = this.customer.customerId
          //this.saleData.products  = res.data.recordsets[0]

          


          this.cart = res.data.recordsets[0]

          let rowIndex = 0
          res.data.recordsets[0].forEach(row =>{
            
           
            
            const type                        = row.type == 1 ? true : false
            this.cart[rowIndex].type          = type
            
            /*  
              this.cart[rowIndex].rowTotal      = this.getRowTotal(this.cart[rowIndex])
            */

            this.cart[rowIndex].discount      = 0
            this.cart[rowIndex].price         = row.rowTotal
            this.cart[rowIndex].rowTotal      = row.rowTotal

            rowIndex++

          })
          this.setScannerOn()  
         
    }
    else if(res.status==500)
    {
      this.waitModal.sentinel = 1
      
      this.dialogBox.show     = true
      this.dialogBox.title    = 'RICERCA VENDITA'
      this.dialogBox.msg      = res.data
      console.log(res.data)
    } 
    else
    {
    	this.waitModal.sentinel = 1
      this.dialogBox.show     = true
      this.dialogBox.title    = 'RICERCA VENDITA'
      this.dialogBox.msg      = res
      console.log(res)
      
      
    } 
    }).catch(err => 
    {
	    this.waitModal.sentinel = 1
      this.dialogBox.show     = true
      this.dialogBox.title    = 'RICERCA VENDITA'
      this.dialogBox.msg      = err
      console.log(err)
      
      
    }).finally(() => {
	    //this.spinner = false
    });
      
    },

    
    scrollToElement(index) 
    {
      const el = this.$el.getElementsByClassName('index-' + index)[0];
      
      if (el) {
        el.scrollIntoView();
      }
    },
    editRowModal(item,rowIndex)
    { 
      
      if(item.flag)
      {
       // return
      }
      if(this.isAdmin == 1)
      {
        item.edit = null
      }       
      this.setScannerOff()
    
      this._price                  = this.cart[rowIndex]['price']  
      this._discount               = this.cart[rowIndex]['discount']  
      this.rowIndex                = rowIndex
      this.rowModal.img            = this.company.img_url + item.img
      
      this.rowModal.price          = item.price
      this.rowModal.discount       = item.discount
      this.rowModal.type           = item.type
      this.rowModal.title          = item.brand + ' ' + item.category + ' ' + item.color + ' ' + item.sku + ' ' + item.department
      this.rowModal.cost_price     = item.cost_price
      this.rowModal.assistant_code = item.assistant_code
      this.rowModal.edit           = item.edit

      this.rowModal.show           = true
        
    },
    roundTo(euro,roundTo) {
      // Moltiplica per 2 per gestire i 50 centesimi
      let importo = euro * roundTo;

      // Arrotonda per eccesso all'intero più vicino
      importo = Math.ceil(importo);
      // Divide per 2 per ottenere l'importo arrotondato ai 50 centesimi
      return importo / roundTo;
    },
    /*
    roundTotalUpDown(total)
    {
      if(total < 0)
      {
        return total
      }

      let t           = Number(Math.round(total + 'e2' ) + 'e-2' ).toLocaleString('en-US', {minimumFractionDigits: 2}).replace(',','')      
      let start       = t.toString().indexOf('.')
      let val         = t.toString().substr(0,start)
      let cent        = t.toString().substr(start + 1,2)

      //let check_digit = cent.substring(2, 1)
      if(Number(cent) > 1 && Number(cent) < 25)
      {          
        val = Number(val) 
      } 
      else if(Number(cent) > 25 && Number(cent) < 51)
      {
       
        val = Number(val) + .50
      }
      else if(Number(cent) > 50 && Number(cent) < 75) 
      {
        val = Number(val) + .50
      }
      else if(Number(cent) > 75 && Number(cent) < 100)
      {
        val = Number(val) + 1
      }
      return Number(val)
    },
    */
    roundTotal(total,round_total)
    {
    
      if(total < 0)
      {
        return total
      }


      const t           = Number(Math.round(total + 'e2' ) + 'e-2' ).toLocaleString('en-US', {minimumFractionDigits: 2}).replace(',','')      
      //console.log('TOTALE',total,t)
      const start       = t.toString().indexOf('.')
      let val           = t.toString().substr(0,start)
      const cent        = t.toString().substr(start + 1,2)
      const check_digit = cent.substring(2, 1)
      
      // MILLESIMI NOT FOUND
      if(check_digit == 0)
      {
        return total
      }

        if(round_total == 50)
        {
          if(Number(cent) > 0 && Number(cent) < 50)
          {          
            val = Number(val) + .50
          }
          else if(Number(cent) > 50 && Number(cent) < 100) 
          {
            val = Number(val) + 1
          }
        }
        else
        { 
        
            val = Number(val) + (Number(cent) + (round_total - check_digit))  / 100                 
          
        }      
      
      return val
    },
      
    

  
 
}
}
</script>
<style scoped>


.btn-block_

{
  background-color : rgb(102, 97, 102);
  color            : white;
  
}

.fixed{
  position: fixed;
}

.my-custom-scrollbar 
{
  position   : relative;
  height     : 650px;
  overflow   : auto;
}


.table-wrapper-scroll-y {
  _display: block;
}

.custom-control-label {
  cursor: pointer;
}


.table-wrapper-scroll-y {
display: block;
}

.pointer:hover {
  background-color: lightblue(182, 216, 241, 0.972);
  color: black;
  cursor: pointer;
}

.cart thead tr:nth-child(1) th {
  font-family : "Roboto Condensed";
  font-size   : 18px;
  
  background  : rgb(10, 110, 5);
  color       : whitesmoke;

  position    : sticky;
  top         : 0;
  z-index     : 10;
}
.table tfoot  tr:nth-child(1) th
 {

    font-family  : 'Roboto Condensed';
    font-size    : 20px;
    background   : whitesmoke;
    color        : black;   
    position     : sticky;
    bottom       : 0;
    z-index      : 10;
    height       : 50px;

 }


h4 {

  font-family: "Roboto Condensed";
  font-size: 20px;
}

.total {
  _font-family: "Roboto Condensed";
  font-size: 35px;
  font-weight:bolder;
  color : darkgreen;
}



input:disabled {
  background: white;
  border: none;
}

.pointer {
  cursor: pointer;
}
.cart th:first-child {
  border-radius: 0 0 0 8px;
}
.cart th:last-child {
  border-radius: 0 8px 0 0;
}

.modal-footer {
  justify-content: space-between;
}



.fas fa-ban
{
  color:red;
}



.main
{
  height:45px;
}        

.rest {
  _font-family: "Roboto Condensed";
  font-size   : 25px;
  font-weight :bolder;
  color       : black
}
.badge{
  font-size: 26px;
}


</style>